module.exports = " <article> <div class=\"container-fluid error row\"> <p class=display-4><span class=display-3>404</span> You took a wrong turn</p> </div> <a class=\"btn btn-primary\" v-link=\"{ path: '/' }\"> Go Home</a> </article> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/404.vue
// module id = 154
// module chunks = 2